<template>
  <layout>
    <loader v-if="loading"></loader>
    <b-alert v-model="isError" variant="danger">{{ error }}</b-alert>
    <b-alert v-model="notFound" variant="danger">{{ $t('dashboards.dashboardNotFound') }}</b-alert>
    <div class="card-body py-0 text-center">
      <router-link
        class="nav-link px-0"
        :to="{ name: boxInfoRoutName, params: { deviceId: deviceIdInternal } }"
      >
        <b-btn large variant="primary" class="btn-md" style="width: 100%">
          <span class="h4">
            <i class="mdi mdi-information-variant btn-icon-prepend h2" style="font-size: 20px"></i>
            {{ $t('settings.toEquipment') }}
          </span>
        </b-btn>
      </router-link>
    </div>
    <iframe
      v-if="!loading && item && dashboardUrl"
      :src="dashboardUrl"
      frameborder="0"
      style="display: block; width: 100%; height: 1100px"
    ></iframe>
  </layout>
</template>

<script>
import boxInfoIiotDashboard from '@/api/boxinfo/boxInfoIiotDashboard.gql';

export default {
  name: 'BoxIiotDashboard',
  props: {
    deviceId: String,
  },
  apollo: {
    item: {
      query: boxInfoIiotDashboard,
      variables() {
        return {
          deviceId: this.deviceIdInternal,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.boxes && queryData.boxes.length) {
          return queryData.boxes[0];
        } else {
          this.error = this.$t('box.error.equipment');
          return null;
        }
      },
      skip() {
        return !this.deviceIdInternal;
      },
      error(e) {
        this.error = e.message;
      },
    },
  },
  data() {
    return {
      boxInfoRoutName: 'Boxinfo',
      item: {},
      error: null,
    };
  },
  computed: {
    height() {
      return window.innerHeight - 150;
    },
    isError() {
      return !!this.error;
    },
    notFound() {
      return !this.loading && this.item && !this.dashboardUrl;
    },
    loading() {
      return this.$apollo.queries.item.loading;
    },
    deviceIdInternal() {
      return this.deviceId ? this.deviceId : this.$route.params.deviceId;
    },
    dashboardUrl() {
      return this.item && this.item.digitalThing && this.item.digitalThing.uiPage
        ? this.item.digitalThing.uiPage.url
        : null;
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated;
    },
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>

<style scoped>
.tab-solid {
  margin-bottom: 0px !important;
}
</style>
